import { useMemo } from 'react';
import { useGetOrganizationsQuery } from '../api';
/**
 * Hook to get all organizations.
 */
export const useOrganizations = () => {
    const { data: organizations = [], isLoading, isError, error } = useGetOrganizationsQuery();
    const sortedOrganizations = useMemo(() => {
        return [...organizations].sort((a, b) => a.name.localeCompare(b.name));
    }, [organizations]);
    return useMemo(() => ({
        organizations: sortedOrganizations,
        isLoading,
        isError,
        error,
    }), [error, isError, isLoading, sortedOrganizations]);
};
